import { formatIsoDateItShort, coerceDateTime } from '@/utils/date';

export function parseDate(value: string | undefined): number | undefined {
  const parsed = value ? coerceDateTime(value) : undefined;
  return parsed ? parsed.getTime() : undefined;
}

export function formatDate(value: string | undefined): string {
  return formatIsoDateItShort(value, '—');
}

export function formatIsoDate(value: string | undefined | null, fallback = '—'): string {
  return formatIsoDateItShort(value, fallback);
}
